















































import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { activityLogName } from "@/lib/utility/activityLogName";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import TimeLineItemText from "../utility/TimeLineItemText.vue";
import SnapshotSideCard from "../handover/SnapshotSideCard.vue";
import { HandoverSnapshotModule } from "@/store/modules/handover-snapshot.store";
import { Snapshot } from "@/models/snapshot.entity";
import { ISnapshotSignRequest, SnapshotSignRequest } from "@/models/snapshot-sign-request.entity";
import { SnapshotSignRequestModule } from "@/store/modules/snapshot-sign-request.store";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";

@Component({
  components: { TimeLineItemText, SnapshotSideCard }
})
export default class ActivityTimeLineItemSnapshotSignRequest extends mixins(DarkModeHighlightMixin, PermissionMixin) {
  @Prop({})
  activityLogEntry!: IActivityLog;

  sharing: ISharedContent | null = null;

  loading = false;

  isSideCardOpen = false;

  snapshotSignRequest: ISnapshotSignRequest | null = null;

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  get date() {
    if (this.activityLogEntry.timestamp?.created) {
      return simpleDoubleDigitDate(this.activityLogEntry.timestamp.created);
    }
    return this.$t("sign.DocumentDetail.noDate");
  }

  get email() {
    const emails = (this.sharing?.emailAddresses ?? []).filter(Boolean);
    return emails.length ? emails[0] : "";
  }

  get snapshotSignRequestId() {
    const target = this.activityLogEntry.target?.find(t => t.refType === BackendResourceEnum.SNAPSHOT_SIGN_REQUEST);
    return target?.refId || "";
  }

  get title() {
    if (this.loading || !this.email) {
      return this.$t("timeLine.ActivityTimeLineItemSnapshotSignRequest.title", {
        name: this.name,
        date: this.date
      });
    }

    return this.$t("timeLine.ActivityTimeLineItemSnapshotSignRequest.titleWithEmail", {
      name: this.name,
      date: this.date,
      email: this.email
    });
  }

  get snapshot() {
    if (!this.snapshotSignRequest) return null;

    const snapshotId = this.snapshotSignRequest.snapshotId;

    const sc = HandoverSnapshotModule.maps.id.get(snapshotId)?.[0];

    if (sc) return sc;

    return new Snapshot({
      partnerId: this.activityLogEntry.partnerId,
      id: snapshotId
    });
  }

  async mounted() {
    if (this.activityLogEntry.activity !== ActivityTypeEnum.REQUEST_SNAPSHOT_SIGNATURE) return;

    if (!this.can(ActionEnum.READ, BackendResourceEnum.SNAPSHOT_SIGN_REQUEST)) {
      return;
    }

    const reqId = this.snapshotSignRequestId;
    if (!reqId) return;

    this.snapshotSignRequest = SnapshotSignRequestModule.maps.id.get(reqId)?.[0] || null;
    if (!this.snapshotSignRequest) {
      try {
        const snapshotSignRequest = new SnapshotSignRequest({
          partnerId: this.activityLogEntry.partnerId,
          id: reqId
        });
        await snapshotSignRequest.fetch();

        this.snapshotSignRequest = snapshotSignRequest;
      } catch (e) {
        this.$log.error(e);
        this.snapshotSignRequest = null;
      }
    }

    try {
      this.loading = true;
      const sharing = await SharedContentModule.fetchByRef({
        partnerId: this.activityLogEntry.partnerId,
        refId: reqId
      });
      this.sharing = sharing ? new SharedContent(sharing[0]) : null;
    } catch (e) {
      this.$log.error(e);
    } finally {
      this.loading = false;
    }
  }

  openSnapshotSideCard() {
    this.isSideCardOpen = true;
  }
}
